const api = {
    home: {
        map: {
            contactDetailsLocations: {
                all: '/locations/get-all?getall=true',
                default: '/locations/get-all'
            }
        },
    },
    applications: '/applications',
    faqs: '/faqs/search',
    closestLocation: '/locations/get-closest',
    pressReleases: '/press-releases',
    searchResult: '/commonsearch',
    resourcesSearchResult: 'resourcesearch',
    blogList: '/blogs/search',
    formSubmit: '/form-submit',
	formSubmitContact: '/form-submit-contact',
    formSubmitCareers: '/form-submit-careers'
}

export default api
